import Vue from "vue";
import VueRouter from "vue-router";

import NbaLayout from "../layout/NBA-panel/NbaLayout";

import OptimizerTab from "../components/Tabs/tabItems/Optimizer/OptimizerTabs.vue";
import InsightTab from "../components/Tabs/tabItems/Insights/InsightTabs.vue";
import BettingVue from "@/components/Tabs/tabItems/BettingTool/Betting.vue";

import SignUp from "../views/UserRegister.vue";
import Login from "../views/UserLogin.vue";
import pricing from "../views/Pricing.vue";
import failure from "../views/failurePage.vue";
import success from "../views/successPage.vue";
import conversionPage from "../views/ConversionSuccess.vue";
import contact from "../views/Contact.vue";
import forgetPassword from "../views/forgotPass.vue";
import allUsers from "../views/AllUsers";
import clickPricingPage from "../views/ClickBank/clickPricing.vue";
import ClickSignUpForm from "../views/ClickBank/clickSignUp.vue";
import ClickSuccessPage from "../views/ClickBank/clickThankYou.vue";
import RecoverPasswordWOtp from "../views/RecoverPwOtp.vue";
import clickbankContact from "../views/ClickBank/clickContact.vue";
import settings from "../views/settings.vue";
import reportTable from "../views/report.vue";

Vue.use(VueRouter);

const routes = [
  //? first page...
  {
    path: "/",
    redirect: "/sign-up",
  },

  {
    path: "/pricing",
    name: "Pricing",
    component: pricing,
  },

  //? click bank routes
  {
    path: "/click/pricing",
    name: "clickPricingPage",
    component: clickPricingPage,
  },

  {
    path: "/click/sign-up",
    name: "ClickSignUpForm",
    component: ClickSignUpForm,
  },
  {
    path: "/click/success",
    name: "ClickSuccessPage",
    component: ClickSuccessPage,
  },

  {
    path: "/click/contact-us",
    name: "ClickBankContactPage",
    component: clickbankContact,
  },
  //? click bank routes ends.

  {
    path: "/sign-up",
    name: "SignUpForm",
    component: SignUp,
    props: true,
  },

  {
    path: "/recover-password",
    name: "forgetPassword",
    component: forgetPassword,
  },

  {
    path: "/reset-password",
    name: "RecoverPasswordWOtp",
    component: RecoverPasswordWOtp,
  },

  {
    path: "/login",
    name: "loginForm",
    component: Login,
  },

  {
    path: "/user/cancel",
    name: "failurePage",
    component: failure,
  },

  {
    path: "/user/success",
    name: "successPage",
    component: success,
  },

  {
    path: "/freeuser/success",
    name: "conversionPage",
    component: conversionPage,
  },

  {
    path: "/contact-us",
    name: "ContactPage",
    component: contact,
  },

  {
    path: "/all-users",
    name: "allUsersTable",
    component: allUsers,
  },

  {
    path: "/settings",
    name: "settings",
    component: settings,
  },

  {
    path: "/report",
    name: "reportTable",
    component: reportTable,
  },

  {
    path: "/login-history",
    name: "loginReport",
    component: () =>
      import(
        /* webpackChunkName: "userLoginHistory" */ "../views/LoginReport.vue"
      ),
  },

  {
    path: "/best-bet",
    name: "bestBetPage",
    component: () =>
      import(/* webpackChunkName: "bestBetPage" */ "../views/BestBetForm.vue"),
  },

  {
    path: "/upgrade-plan",
    name: "upgradePlan",
    component: () =>
      import(/* webpackChunkName: "upgradePlan" */ "../views/upgradePlan.vue"),
    props: true,
  },

  {
    path: "/verifyemail/:email/:otp",
    name: "verifyEmail",
    component: () =>
      import(
        /* webpackChunkName: "verifyEmail" */ "../views/verifyEmailPage.vue"
      ),
    props: true,
  },

  /* MARKETING PAGE */
  {
    path: "/nfl-optimizer",
    name: "NflDemoPositionOptiPage",
    component: () =>
      import(
        /* webpackChunkName: "NflDemoPositionOptiPage" */ "../views/Marketing/NFL/NflPositionOpti.vue"
      ),
    props: true,
  },

  {
    path: "/nhl-optimizer",
    name: "NhlDemoPositionOptiPage",
    component: () =>
      import(
        /* webpackChunkName: "NhlDemoPositionOptiPage" */ "../views/Marketing/NHL/NhlPositionOpti.vue"
      ),
    props: true,
  },

  //Props..
  {
    path: "/nhl-props",
    name: "NhlDemoProjection",
    component: () =>
      import(
        /* webpackChunkName: "NhlDemoProjection" */ "../views/Marketing/NHL/NhlProjection.vue"
      ),
    props: true,
  },

  {
    path: "/nfl-props",
    name: "NflDemoProjection",
    component: () =>
      import(
        /* webpackChunkName: "NflDemoProjection" */ "../views/Marketing/NFL/NflProjection.vue"
      ),
    props: true,
  },
  {
    path: "/nba-props",
    name: "NbaDemoProjection",
    component: () =>
      import(
        /* webpackChunkName: "NbaDemoProjection" */ "../views/Marketing/NBA/NbaProjection.vue"
      ),
    props: true,
  },
  {
    path: "/mlb-props",
    name: "MlbDemoProjection",
    component: () =>
      import(
        /* webpackChunkName: "MlbDemoProjection" */ "../views/Marketing/MLB/MlbProjection.vue"
      ),
    props: true,
  },

  // News...
  {
    path: "/mlb-news",
    name: "MlbDemoNewsPage",
    component: () =>
      import(
        /* webpackChunkName: "MlbDemoNewsPage" */ "../views/Marketing/MLB/MlbNews.vue"
      ),
    props: true,
  },

  {
    path: "/nhl-news",
    name: "NhlDemoNewsPage",
    component: () =>
      import(
        /* webpackChunkName: "NhlDemoNewsPage" */ "../views/Marketing/NHL/NhlNews.vue"
      ),
    props: true,
  },

  {
    path: "/nba-news",
    name: "NbaDemoNewsPage",
    component: () =>
      import(
        /* webpackChunkName: "NbaDemoNewsPage" */ "../views/Marketing/NBA/NbaNews.vue"
      ),
    props: true,
  },

  {
    path: "/nfl-news",
    name: "NflDemoNewsPage",
    component: () =>
      import(
        /* webpackChunkName: "NflDemoNewsPage" */ "../views/Marketing/NFL/NflNews.vue"
      ),
  },

  {
    path: "/nhl-starting-goalies",
    name: "NhlDemoStartGoalies",
    component: () =>
      import(
        /* webpackChunkName: "NhlDemoStartGoalies" */ "../views/Marketing/NHL/NhlStartGoalies.vue"
      ),
  },

  {
    path: "/nhl-starting-goalies-widget",
    name: "NhlGoaliesSection",
    component: () =>
      import(
        /* webpackChunkName: "NhlGoaliesSection" */ "../views/Marketing/Sections/NhlGoaliesSection.vue"
      ),
  },

  {
    path: "/mlb-daily-lineups",
    name: "MlbDemoDailyLineups",
    component: () =>
      import(
        /* webpackChunkName: "MlbDemoDailyLineups" */ "../views/Marketing/MLB/MlbDailyLineups.vue"
      ),
  },

  {
    path: "/mlb-daily-lineups-widget",
    name: "GameDaySection",
    component: () =>
      import(
        /* webpackChunkName: "GameDaySection" */ "../views/Marketing/Sections/MlbGameDaySection.vue"
      ),
  },

  {
    path: "/news-widget",
    name: "NewsSection",
    component: () =>
      import(
        /* webpackChunkName: "NewsSection" */ "../views/Marketing/Sections/NewsSection.vue"
      ),
  },

  {
    path: "/nba-daily-lineups",
    name: "NbaDemoGameDay",
    component: () =>
      import(
        /* webpackChunkName: "NbaDemoGameDay" */ "../views/Marketing/NBA/NbaGameDay.vue"
      ),
  },
  {
    path: "/nba-daily-lineups-widget",
    name: "NbaGameDaySection",
    component: () =>
      import(
        /* webpackChunkName: "NbaGameDaySection" */ "../views/Marketing/Sections/NbaGameDaySection.vue"
      ),
  },

  //Projection..
  {
    path: "/nhl-projection",
    name: "NhlDemoTopPlayers",
    component: () =>
      import(
        /* webpackChunkName: "NhlDemoTopPlayers" */ "../views/Marketing/NHL/NhlTopPlayer.vue"
      ),
  },

  {
    path: "/nfl-projection",
    name: "NflDemoTopPlayers",
    component: () =>
      import(
        /* webpackChunkName: "NflDemoTopPlayers" */ "../views/Marketing/NFL/NflTopPlayer.vue"
      ),
  },
  {
    path: "/nba-projection",
    name: "NbaDemoTopPlayers",
    component: () =>
      import(
        /* webpackChunkName: "NbaDemoTopPlayers" */ "../views/Marketing/NBA/NbaTopPlayer.vue"
      ),
  },
  {
    path: "/mlb-projection",
    name: "MlbDemoTopPlayers",
    component: () =>
      import(
        /* webpackChunkName: "MlbDemoTopPlayers" */ "../views/Marketing/MLB/MlbTopPlayer.vue"
      ),
  },

  {
    path: "/:id/:operator/",
    name: "NbaLayout",
    component: NbaLayout,
    meta: { requireAuth: true },
    children: [
      // ? optimizer...
      {
        path: "optimizer",
        // redirect: "optimizer/position-optimizer-nba",
        name: "OptimizerTab",
        component: OptimizerTab,

        children: [
          // * NBA...
          {
            path: "position-optimizer-nba",
            name: "nbaPositionOpti",
            component: () =>
              import(
                /* webpackChunkName: "NbaPositionOpti" */ "../views/NBA/NbaPositionOpti.vue"
              ),
            props: true,
          },
          {
            path: "saved-lineup-nba",
            name: "nbaSavedLineup",
            component: () =>
              import(
                /* webpackChunkName: "NbaSavedLineup" */ "../views/NBA/NbaSavedLineup.vue"
              ),
            props: true,
          },

          // * MLB...
          {
            path: "position-optimizer-mlb",
            name: "MlbPositionOpti",
            component: () =>
              import(
                /* webpackChunkName: "MlbPositionOpti" */ "../views/MLB/MlbPositionOpti.vue"
              ),
            props: true,
          },
          {
            path: "saved-lineup-mlb",
            name: "MlbSavedLineup",
            component: () =>
              import(
                /* webpackChunkName: "MlbSavedLineup" */ "../views/MLB/MlbSavedLineup.vue"
              ),
            props: true,
          },

          // * Nhl....
          {
            path: "position-optimizer-nhl",
            name: "NhlPositionOpti",
            component: () =>
              import(
                /* webpackChunkName: "NhlPositionOpti" */ "../views/NHL/NhlPositionOpti.vue"
              ),
            props: true,
          },
          {
            path: "saved-lineup-nhl",
            name: "NhlSavedLineup",
            component: () =>
              import(
                /* webpackChunkName: "NhlSavedLineup" */ "../views/NHL/NhlSavedLineup.vue"
              ),
            props: true,
          },

          // * Nfl....
          {
            path: "position-optimizer-nfl",
            name: "NflPositionOpti",
            component: () =>
              import(
                /* webpackChunkName: "NflPositionOpti" */ "../views/NFL/NflPositionOpti.vue"
              ),
            props: true,
          },
          {
            path: "saved-lineup-nfl",
            name: "NflSavedLineup",
            component: () =>
              import(
                /* webpackChunkName: "NflSavedLineup" */ "../views/NFL/NflSavedLineup.vue"
              ),
            props: true,
          },
        ],
      },

      // ? insights..
      {
        path: "insight/",
        // redirect: "insight/teams-nba",
        name: "InsightTab",
        component: InsightTab,

        children: [
          // * NBA....
          {
            path: "teams-nba",
            name: "NbaBrowseTeam",
            component: () =>
              import(
                /* webpackChunkName: "NbaBrowseTeam" */ "../views/NBA/NbaBrowseTeam.vue"
              ),
            props: true,
          },
          {
            path: "top-players-nba",
            name: "NbaTopPlayers",
            component: () =>
              import(
                /* webpackChunkName: "NbaTopPlayer" */ "../views/NBA/NbaTopPlayer.vue"
              ),
            props: true,
          },
          {
            path: "daily-lineups-nba",
            name: "NbaDailyLineups",
            component: () =>
              import(
                /* webpackChunkName: "NbaDailyLineups" */ "../views/NBA/NbaDailyLineups"
              ),
            props: true,
          },

          {
            path: "player-trends-nba",
            name: "NbaPlayerTrends",
            component: () =>
              import(
                /* webpackChunkName: "NbaTrends" */ "../views/NBA/NbaPlayerTrends.vue"
              ),
            props: true,
          },
          {
            path: "news-nba",
            name: "NbaNews",
            component: () =>
              import(
                /* webpackChunkName: "NbaNews" */ "../views/NBA/NbaNews.vue"
              ),
          },
          {
            path: "propick-nba",
            name: "NbaProPick",
            component: () =>
              import(
                /* webpackChunkName: "NbaProPicks" */ "../views/NBA/NbaProPick.vue"
              ),
          },

          // * MLB...
          {
            path: "teams-mlb",
            name: "MlbBrowseTeam",
            component: () =>
              import(
                /* webpackChunkName: "MlbBrowseTeam" */ "../views/MLB/MlbBrowseTeam.vue"
              ),
            props: true,
          },

          {
            path: "mlb-average-draft-point",
            name: "MlbAdp",
            component: () =>
              import(
                /* webpackChunkName: "MlbAdp" */ "../views/MLB/MlbAdp.vue"
              ),
            props: true,
          },

          {
            path: "top-players-mlb",
            name: "MlbTopPlayers",
            component: () =>
              import(
                /* webpackChunkName: "MlbTopPlayer" */ "../views/MLB/MlbTopPlayer.vue"
              ),
            props: true,
          },
          {
            path: "daily-lineups-mlb",
            name: "MlbDailyLineups",
            component: () =>
              import(
                /* webpackChunkName: "MlbDailyLineups" */ "../views/MLB/MlbDailyLineups"
              ),
            props: true,
          },

          {
            path: "player-trends-mlb",
            name: "MlbPlayerTrends",
            component: () =>
              import(
                /* webpackChunkName: "MlbPlayerTrends" */ "../views/MLB/MlbPlayerTrends.vue"
              ),
            props: true,
          },
          {
            path: "news-mlb",
            name: "MlbNews",
            component: () =>
              import(
                /* webpackChunkName: "MlbNews" */ "../views/MLB/MlbNews.vue"
              ),
          },

          // * NHL...
          {
            path: "teams-nhl",
            name: "NhlBrowseTeam",
            component: () =>
              import(
                /* webpackChunkName: "NhlBrowseTeam" */ "../views/NHL/NhlBrowseTeam.vue"
              ),
            props: true,
          },
          {
            path: "top-players-nhl",
            name: "NhlTopPlayers",
            component: () =>
              import(
                /* webpackChunkName: "NhlTopPlayer" */ "../views/NHL/NhlTopPlayer.vue"
              ),
            props: true,
          },
          {
            path: "line-combination-nhl",
            name: "NhlLineComb",
            component: () =>
              import(
                /* webpackChunkName: "NhlLineComb" */ "../views/NHL/NhlLineCombination.vue"
              ),
            props: true,
          },

          {
            path: "starting-goalies-nhl",
            name: "NhlStartGoalies",
            component: () =>
              import(
                /* webpackChunkName: "NhlStartGoalies" */ "../views/NHL/NhlStartGoalies.vue"
              ),
            props: true,
          },

          {
            path: "player-trends-nhl",
            name: "NhlPlayerTrends",
            component: () =>
              import(
                /* webpackChunkName: "NhlPlayerTrends" */ "../views/NHL/NhlPlayerTrends.vue"
              ),
            props: true,
          },
          {
            path: "news-nhl",
            name: "NhlNews",
            component: () =>
              import(
                /* webpackChunkName: "NhlNews" */ "../views/NHL/NhlNews.vue"
              ),
          },

          // * NFL...
          {
            path: "teams-nfl",
            name: "NflBrowseTeam",
            component: () =>
              import(
                /* webpackChunkName: "NflBrowseTeam" */ "../views/NFL/NflBrowseTeam.vue"
              ),
            props: true,
          },

          {
            path: "top-players-nfl",
            name: "NflTopPlayers",
            component: () =>
              import(
                /* webpackChunkName: "NflTopPlayer" */ "../views/NFL/NflTopPlayer.vue"
              ),
            props: true,
          },

          {
            path: "nfl-average-draft-point",
            name: "NflAdp",
            component: () =>
              import(
                /* webpackChunkName: "NflAdp" */ "../views/NFL/NflAdp.vue"
              ),
            props: true,
          },

          {
            path: "player-trends-nfl",
            name: "NflPlayerTrends",
            component: () =>
              import(
                /* webpackChunkName: "NflPlayerTrends" */ "../views/NFL/NflPlayerTrends.vue"
              ),
            props: true,
          },
          {
            path: "propick-nfl",
            name: "NflProPick",
            component: () =>
              import(
                /* webpackChunkName: "NflProPick" */ "../views/NFL/NflProPick.vue"
              ),
          },

          {
            path: "news-nfl",
            name: "NflNews",
            component: () =>
              import(
                /* webpackChunkName: "NflNews" */ "../views/NFL/NflNews.vue"
              ),
          },

          {
            path: "news-ranks",
            name: "NflRankings",
            component: () =>
              import(
                /* webpackChunkName: "NflRankings" */ "../views/NFL/NflRankings.vue"
              ),
          },
          {
            path: "nfl-depth-chart",
            name: "NflTeamDepth",
            component: () =>
              import(
                /* webpackChunkName: "nflTeamDepth" */ "../views/NFL/NflTeamDepth.vue"
              ),
          },

          {
            path: `nfl-matchup?fdw-gameId=:gameId`,
            name: "NflMatchup",
            component: () =>
              import(
                /* webpackChunkName: "NflMatchup" */ "../views/NFL/NflMatchup.vue"
              ),
            props: true,
          },

          {
            path: "nfl-ticker",
            name: "NflTicker",
            component: () =>
              import(
                /* webpackChunkName: "NflTicker" */ "../views/NFL/NflTicker.vue"
              ),
          },

          {
            path: "nfl-odds",
            name: "NflOdds",
            component: () =>
              import(
                /* webpackChunkName: "NflOdds" */ "../views/NFL/NflOdds.vue"
              ),
          },
        ],
      },

      // ? Betting tool...
      {
        path: "betting/",
        name: "Betting",
        component: BettingVue,
        children: [
          //* Mlb...
          {
            path: "props/projection-mlb",
            name: "MlbProjection",
            component: () =>
              import(
                /* webpackChunkName: "MlbProjection" */ "../views/MLB/MlbProjection.vue"
              ),
            props: true,
          },

          {
            path: "prop-finder",
            name: "Mlbpropfinder",
            component: () =>
              import(
                /* webpackChunkName: "Mlbpropfinder" */ "../views/MLB/MlbPropFind.vue"
              ),
          },

          {
            path: "sport-book",
            name: "MlbSportsBook",
            component: () =>
              import(
                /* webpackChunkName: "MlbSportsBook" */ "../views/MLB/MlbSportsBook.vue"
              ),
          },

          //* Nfl...
          {
            path: "props/projection-nfl",
            name: "NflProjection",
            component: () =>
              import(
                /* webpackChunkName: "NflProjection" */ "../views/NFL/NflProjection.vue"
              ),
            props: true,
          },
          {
            path: "prop-finder",
            name: "Nflpropfinder",
            component: () =>
              import(
                /* webpackChunkName: "Nflpropfinder" */ "../views/NFL/NflPropFind.vue"
              ),
          },
          {
            path: "sport-book",
            name: "NflSportsBook",
            component: () =>
              import(
                /* webpackChunkName: "NflSportsBook" */ "../views/NFL/NflSportsBook.vue"
              ),
          },

          {
            path: "nfl-best-bet",
            name: "NflBestBet",
            component: () =>
              import(
                /* webpackChunkName: "NflBestBet" */ "../views/NFL/NflBestBet.vue"
              ),
          },

          {
            path: "nfl-best-bet-props",
            name: "NflBestBetProps",
            component: () =>
              import(
                /* webpackChunkName: "NflBestBetProps" */ "../views/NFL/NflBestBetProp.vue"
              ),
          },

          //* Nba...
          {
            path: "props/projection-nba",
            name: "NbaProjection",
            component: () =>
              import(
                /* webpackChunkName: "NbaProjection" */ "../views/NBA/NbaProjection.vue"
              ),
            props: true,
          },

          {
            path: "prop-finder",
            name: "NbaPropFinder",
            component: () =>
              import(
                /* webpackChunkName: "NbaPropFinder" */ "../views/NBA/NbaPropFind.vue"
              ),
          },

          {
            path: "sport-book",
            name: "NbaSportsBook",
            component: () =>
              import(
                /* webpackChunkName: "NbaSportsBook" */ "../views/NBA/NbaSportsBook.vue"
              ),
          },
        ],
      },

      //* Nhl...
      {
        path: "props/projection-nhl",
        name: "NhlProjection",
        component: () =>
          import(
            /* webpackChunkName: "NhlProjection" */ "../views/NHL/NhlProjection.vue"
          ),
        props: true,
      },

      //* universal...
      {
        path: "team-profile/:teamId",
        name: "TeamProfile",
        component: () =>
          import(
            /* webpackChunkName: "TeamProfile" */ "../views/NBA/NbaTeamProfile.vue"
          ),
        props: true,
      },

      {
        path: "player-details/:playerId",
        name: "PlayerDetail",
        component: () =>
          import(
            /* webpackChunkName: "playerDetail" */ "../components/Tabs/PlayerDetails.vue"
          ),
        props: true,
      },
      // *......

      // ?NBA...
      {
        path: "nba-team-stack/:slateId",
        name: "nbaTeamStack",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "NbaTeamStack" */ "../views/NBA/NbaTeamStack.vue"
          ),
      },
      {
        path: "nba-top-plays/:role",
        name: "nbaTopPlaysClient",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "NbaTopPlayersClient" */ "../views/NBA/TopPlayers/TopPlaysCLient.vue"
          ),
      },

      // ? Mlb...
      {
        path: "mlb-team-stack/:slateId",
        name: "mlbTeamStack",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "MlbTeamStack" */ "../views/MLB/MlbTeamStack.vue"
          ),
      },
      {
        path: "mlb-top-plays/:role",
        name: "mlbTopPlaysClient",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "MlbTopPlayersClient" */ "../views/MLB/TopPlayers/TopPlaysCLient.vue"
          ),
      },

      // ? Nhl...
      {
        path: "nhl-team-stack/:slateId",
        name: "nhlTeamStack",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "nhlTeamStack" */ "../views/NHL/NhlTeamStack.vue"
          ),
      },

      {
        path: "nhl-top-plays/:role",
        name: "nhlTopPlaysClient",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "NhlTopPlayersClient" */ "../views/NHL/TopPlayers/TopPlayersClient.vue"
          ),
      },

      // ? Nfl...
      {
        path: "nfl-team-stack/:slateId",
        name: "nflTeamStack",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "nflTeamStack" */ "../views/NFL/NflTeamStack.vue"
          ),
      },
      {
        path: "nfl-top-plays/:role",
        name: "nflTopPlaysClient",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "NflTopPlayersClient" */ "../views/NFL/TopPLayers/TopPlayersClient.vue"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   const loggedIn = localStorage.getItem("user");
//   const PaymentStatus = localStorage.getItem("status");
//   if (to.matched.some((record) => record.meta.requireAuth)) {
//     if (!loggedIn) {
//       next("/login");
//     } else if (PaymentStatus === "inactive" || PaymentStatus === "undefined") {
//       // store.dispatch('NbaModule/userLogout');
//       next("/pricing");
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
